'use client'

import { OutlinedButton } from '@dfds-pax/ui'

interface Props {
  text: string
  onClicked: () => void
}

const LogoutButton: React.FC<Props> = ({ text, onClicked }) => {
  return (
    <div data-e2e-logout className="login-w-full">
      <OutlinedButton className="ui-w-full" onClick={onClicked}>
        {text}
      </OutlinedButton>
    </div>
  )
}

export default LogoutButton
